import * as React from 'react';
import Select from 'react-select';
import { Translation } from "react-i18next";
class DropDown extends React.Component {
 
  state = { isOpen: false };

  toggleOpen = () => {
    this.setState(state => ({ isOpen: !state.isOpen }));
  };
 
  componentDidUpdate(prevProps) {
    if (prevProps.selectedlabel !== this.props.selectedlabel) {
      this.setState({
        isOpen: false
      })
    }
  }
  render() {
    const { label, selected, required, onChange, className, selectedlabel } = this.props;
    let {listitems } = this.props;

    const { isOpen } = this.state;
    const isSearchable =
      this.props.isSearchable !== undefined
        ? this.props.isSearchable
        : true;
    const isDisabled =
      this.props.isDisabled !== undefined
        ? this.props.isDisabled
        : false;
    const isMulti =
      this.props.isMulti !== undefined
        ? this.props.isMulti
        : false;
      const menuPortalZIndex = this.props.menuPortalZIndex !== undefined ? this.props.menuPortalZIndex : 9999;
   let options = (Array.isArray(listitems) ? listitems.filter(item => item != null && typeof item === 'object') : []).map((item, index) => {
          try {
            return {
              label: item && item.name ? item.name : (item && item.attendee_type ? item.attendee_type : ''),
              value: item && item.id ? item.id : '',
              key: index
            };
          } catch (error) {
            return {
              label: 'Invalid Item',
              value: '',
              key: index
            };
          }
        });
    options =
      this.props.isGroup !== undefined
        ? (Array.isArray(listitems) ? listitems.filter(item => item != null && typeof item === 'object') : [])
        : (Array.isArray(listitems) ? listitems.filter(item => item != null && typeof item === 'object') : []).map((item, index) => {
          try {
            return {
              label: item && item.name ? item.name : (item && item.attendee_type ? item.attendee_type : ''),
              value: item && item.id ? item.id : '',
              key: index
            };
          } catch (error) {
            return {
              label: 'Invalid Item',
              value: '',
              key: index
            };
          }
        });


    const style = {
      control: base => ({
        ...base,
        border: '1px solid #d5d5d5',
        backgroundColor: '#fff',
        zIndex: 9999,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1) ',
        marginTop: '10px',
        minHeight: '48px',
        "&:hover": {
          borderColor: "#117093",
        },

      }),
      menu: base => ({
        ...base,
        zIndex: 9999
      }),
      menuPortal: base => ({
        ...base,
        zIndex: 9999
      }),
      menuList: base => ({
        ...base,
        maxHeight: '300px'
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
          ? "#117093"
          : "rgba(var(--darkbox), 0.3)",
        color: state.isSelected ? "#fff" : "#6D6D6D",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#57c6eb",
          color: "#fff",
        },
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: "#d5d5d5",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: "#d5d5d5",
        "&:hover": {
          color: "#d5d5d5",
        },
      }),
    };

    const Blanket = props => (
      <div
        className="blanket-wrapper"
        onClick={props.onClick}
      />
    );
    const DropdownIndicator = () => (
      <div style={{ color: '#cccccc', height: 24, width: 32 }}>
        <Svg>
          <path
            d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </Svg>
      </div>
    );
    const Svg = p => (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        focusable="false"
        role="presentation"
        {...p}
      />
    );

    return (
      <Translation>
        {(t) => {
          if (this.props.type !== undefined && this.props.type === 'attendee_type') {
            options.unshift({
              label: t("SELECT_ATTENDEE_TYPE"),
              value: 'select',
              key: 'select'
            });
          }
          const displayLabel = (selected === 'select' && this.props.type === 'attendee_type') 
            ? t("SELECT_ATTENDEE_TYPE") 
            : selectedlabel;
          return (
          <React.Fragment>
            {selected && displayLabel && !isMulti ? (
              <div
                className={`${
                  selected && !label
                    ? "no-label wrapper-select isSelected"
                    : selected
                    ? "wrapper-select isSelected"
                    : "wrapper-select"
                } ${isOpen && "isOpen"} ${isDisabled && "isDisabled"} ${
                  !isSearchable && "searchFalse"
                }`}
              >
                <label
                  onClick={(e) => {
                    if (!isDisabled) {
                      this.toggleOpen();
                    }
                  }}
                  className="label-wrapper-select"
                  style={{ cursor: 'pointer' }}
                >
                  <div className="btn-wrapper">{displayLabel}</div>
                  {label && (
                    <span className="label-text">
                      {label} {required && <em className="req">*</em>}{" "}
                    </span>
                  )}
                  <i className="icon-right material-symbols-outlined">
                    {isDisabled ? "lock" : "keyboard_arrow_down"}
                  </i>
                  {this.props.isClearable && onChange && !isDisabled && (
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onChange(e);
                      }}
                      aria-hidden="true"
                      className="dropdown-clearall"
                    >
                      <svg style={{ pointerEvents: 'none' }} height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg">
                        <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                      </svg>
                    </div>
                  )}
                </label>
                {isOpen && !isDisabled && (
                  <Select
                    autoFocus
                    backspaceRemovesValue={false}
                    className={className}
                    components={{ DropdownIndicator, IndicatorSeparator: null }}
                    value={
                      selected
                        ? { label: displayLabel, value: selected }
                        : false
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption && onChange) {
                        onChange(selectedOption);
                      }
                      this.toggleOpen();
                    }}
                    options={options}
                    placeholder={t("G_SEARCH")}
                    styles={style}
                    controlShouldRenderValue={false}
                    isClearable={false}
                    hideSelectedOptions={false}
                    isSearchable={isSearchable}
                    isDisabled={isDisabled}
                    menuIsOpen={true}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    onMenuClose={this.toggleOpen}
                  />
                )}

                {/* Removed Blanket component - react-select handles outside clicks */}
              </div>
            ) : isMulti ? (
                <label className={`${isDisabled && "isDisabled"} wrapper-select select-multi`}>
                <Select
                  autoFocus={isDisabled ? false : true }
                  components={{ IndicatorSeparator: null }}
                  backspaceRemovesValue={false}
                  className={className}
                  value={selected}
                  onChange={onChange}
                  options={options}
                  promptTextCreator={false}
                  placeholder={label ? label : t("G_SEARCH")}
                  styles={style}
                  controlShouldRenderValue={isMulti ? true : false}
                  hideSelectedOptions={false}
                  isClearable={false}
                  isSearchable={true}
                  isMulti={isMulti}
                  />
                </label>
            ) : (
              <div
                className={`wrapper-select ${isOpen && "isOpen"} ${
                  !isSearchable && "searchFalse"
                } ${isDisabled && "isDisabled"}`}
              >
                <label
                  onClick={(e) => {
                    if (!isDisabled) {
                      this.toggleOpen();
                    }
                  }}
                  className="label-wrapper-select"
                  style={{ cursor: 'pointer' }}
                >
                  <div className="btn-wrapper">
                    {label} {required && <em className="req">*</em>}
                  </div>
                  {label && (
                    <span className="label-text">
                      {label} {required && <em className="req">*</em>}{" "}
                    </span>
                  )}
                  <i className="icon-right material-symbols-outlined">
                    {isDisabled ? "lock" : "keyboard_arrow_down"}
                  </i>
                </label>
                {isOpen && !isDisabled && (
                  <Select
                    autoFocus
                    components={{ DropdownIndicator, IndicatorSeparator: null }}
                    backspaceRemovesValue={false}
                    className={className}
                    value={selected || null}
                    onChange={(selectedOption) => {
                      if (selectedOption && onChange) {
                        onChange(selectedOption);
                      }
                      this.toggleOpen();
                    }}
                    options={options}
                    placeholder={t("G_SEARCH")}
                    styles={style}
                    controlShouldRenderValue={isMulti ? true : false}
                    hideSelectedOptions={false}
                    isSearchable={isSearchable}
                    isClearable={false}
                    isMulti={isMulti}
                    menuIsOpen={true}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    onMenuClose={this.toggleOpen}
                  />
                )}
                {/* Removed Blanket component - react-select handles outside clicks */}
              </div>
            )}
          </React.Fragment>
          );
        }}
      </Translation>
    );
  }
}

export default DropDown;